/**
 * Paleta de colors dels actors estratègics.
 *
 * Viu aquí perquè la fan servir dues pantalles: on es creen els actors
 * (StrategicEnvironment) i el llenç on el color s'arrossega a totes les caixes
 * (StrategyMapping). Abans n'hi havia una còpia a cada fitxer, i és per això
 * que es podien desincronitzar.
 *
 * D'on surten aquests cinc colors
 * ------------------------------
 * Abans n'hi havia setze, però eren tres grisos, tres liles, tres verds i
 * quatre marrons/vermells foscos —dos literalment etiquetats «deep red»—.
 * Costaven de distingir, i com que el color de l'actor es propaga a totes les
 * seves capacitats i intencions del mapa, la confusió es multiplicava.
 *
 * Aquests són el conjunt més gran que passa la validació de paletes
 * categòriques comprovant TOTES les parelles, no només les veïnes: aquí els
 * colors els tria l'usuari i qualsevol dos poden acabar de costat.
 *
 * Hi ha dues restriccions alhora:
 *
 *  1. Prou foscos perquè el text blanc de dins la caixa es llegeixi. Tots per
 *     damunt de 4,5:1 sobre blanc.
 *  2. Prou separats per a qui té daltonisme.
 *
 * Amb vuit no hi havia manera: el lila i el blau són pràcticament el mateix per
 * a un deuteranop (ΔE 0,4), i el vermell i el taronja costen de distingir fins
 * i tot amb visió normal (ΔE 6,0). La pitjor parella d'aquests cinc es queda a
 * ΔE 7,3, cosa que és acceptable NOMÉS perquè el color mai és l'única pista:
 * cada caixa del mapa porta el nom de l'actor escrit a sota, i tant el plafó
 * lateral com la llista de l'entorn estratègic els identifiquen pel nom.
 *
 * Si en canvies cap, torna a passar el validador amb --pairs all.
 */
export const COLORS_ACTOR = [
  '#1D4ED8', // blau
  '#A16207', // ambre
  '#047857', // verd
  '#A21CAF', // magenta
  '#991B1B', // vermell fosc
  '#475569'  // gris pissarra
];

/** El que es proposa quan crees un actor nou. */
export const COLOR_ACTOR_PER_DEFECTE = COLORS_ACTOR[0];
